export default __webpack_public_path__ + "static/media/star-cluster-yellow.1678b4e0.svg";